import { render, staticRenderFns } from "./PatentOfficialDeadlineLogReport.vue?vue&type=template&id=1b070f02&"
import script from "./PatentOfficialDeadlineLogReport.vue?vue&type=script&lang=js&"
export * from "./PatentOfficialDeadlineLogReport.vue?vue&type=script&lang=js&"
import style0 from "./PatentOfficialDeadlineLogReport.vue?vue&type=style&index=0&id=1b070f02&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports